export const calculateStartingPosition = (
  ...arr: (number | undefined)[]
): number => {
  const initialPosition = 1;
  return arr.reduce((a, b) => (a || 0) + (b || 0), initialPosition) || 0;
};
